/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ValidationWorkflowDropdown = zod.strictObject({
    value: zod.number(),
    label: zod.string(),
});

export type ValidationWorkflowDropdown = zod.input<
    typeof ValidationWorkflowDropdown
>;
export type ValidationWorkflowDropdownOutput = zod.output<
    typeof ValidationWorkflowDropdown
>;
